export default "__VITE_ASSET__DFAUua8Y__"